import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import btools from "./utils/BTools";
import {
  Col,
  Row,
  Icon,
  Popup,
  Toast,
  DatetimePicker,
  Picker,
  Search,
  Dialog,
  Notify,
  Overlay,
  PullRefresh,
  List,
  Loading,
  Field
} from "vant";
import "vant/lib/index.css";
import Router from "vue-router";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import axios from "axios";
import Storage from "storejs";
import querystring from "querystring";

Vue.config.productionTip = false;
Vue.use(Col);
Vue.use(Row);
Vue.use(Icon);
Vue.use(Popup);
Vue.use(Toast);
Vue.use(DatetimePicker);
Vue.use(Picker);
Vue.use(Search);
Vue.use(Dialog);
Vue.use(Notify);
Vue.use(Overlay);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(Loading);
Vue.use(Field);
const url = {
  token_url: "/o/oauth/token",
  api_url: "/upms/api/v1"
};
axios.defaults.baseURL = ""; //process.env.API;
Vue.prototype.$http = axios;
Vue.prototype.$initUrl = url;
Vue.prototype.$btools = btools;
Vue.prototype.$storage = Storage;
Vue.prototype.$qstring = querystring;

/* leaflet icon */
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
//请求前拦截(拼接token)
axios.interceptors.request.use(
  config => {
    const _flag = (config.url.indexOf("/api/v1") > 0)
    if (config != null && config.url && config.url != null && _flag) {
      if (config.url.indexOf('?') > 0) {
        config.url = config.url + '&'
      } else {
        config.url = config.url + '?'
      }
      let access_token = ''
      if (Storage.get('sso') && Storage.get('sso') !== '') {
        access_token = Storage.get('sso').access_token
      }
      config.url = `${config.url}access_token=${access_token}`
      console && console.log('请求地址：', config.url)
    }
    store.dispatch('setHttpState',true)
    return config;
  },
  error => {
    console && console.log("请求错误", error);
    store.dispatch('setHttpState',false)
    // 请求错误时做些事
    return Promise.reject(error);
  }
);

//返回前拦截(对非200状态的自定义处理)
axios.interceptors.response.use(
  response => {
    store.dispatch('setHttpState',false)
    return response;
  },
  error => {
    store.dispatch('setHttpState',false)
    //对错误进行自定义处理
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求错误'
          break

        case 401:
          error.code = 401
          error.message = '未授权，请登录'
          store.dispatch("checkTokens")
          //router.push({ path: '../SignIn' })
          break

        case 403:
          error.message = '拒绝访问'
          break

        case 404:
          error.message = `请求地址出错: ${error.response.config.url}`
          break

        case 408:
          error.message = '请求超时'
          break

        case 500:
          error.message = '服务器内部错误'
          break

        case 501:
          error.message = '服务未实现'
          break

        case 502:
          error.message = '网关错误'
          break

        case 503:
          error.message = '服务不可用'
          break

        case 504:
          error.message = '网关超时'
          break

        case 505:
          error.message = 'HTTP版本不受支持'
          break

        default:
      }
    }
    return Promise.reject(error);
  }
);
//网页授权或用户注册
const authorization = function(userinfo, to, from, next) {
  //不存在用户信息的处理
  if (userinfo == "undefined" || !userinfo) {
    //if (process.env.NODE_ENV != "production") {
    /*if (document.domain == "localhost" || document.domain == "192.168.0.102") {
      Storage.set("openid", "oHzdjwBdI4RkRWFIQu8O5Xi0zCOQ");
    }*/
    let _openid = Storage.get("openid");
    if (_openid && _openid != "undefined") {
      store.dispatch("getUpmsUser", {
        ele: Vue.prototype,
        success: function(result) {
          if (result != "" && result.data.length > 0) {
            //跳过网页授权流程,进入注册。
            //通过openid 获取用户
            if (to.fullPath === "/Home") {
              next();
            } else {
              next("/Home");
            }
          } else {
            if (to.fullPath === "/register") {
              next();
            } else {
              next("/register");
            }
          }
        },
        fail: function(err) {
          console.log("authorization->err", err);
        }
      });
      //router.routes.push("");
    } else {
      //进行网页授权
      const code = btools.fuc.getUrlParam("code"); //获取url 上面的code
      //alert('code:'+code);
      console.log("code:", code);
      //截取当前回调传回的code参数
      if (code) {
        axios
          .get(url.api_url + "/wx/getWxCode?code=" + code)
          .then(function(res) {
            if (res.status == 200) {
              let _data = JSON.parse(res.data.data); //响应数据
              console.log("网页授权用户信息：", _data);
              Storage.set("wx_user", _data);
              store.commit("SET_OPENID", _data.openid);
              if (to.fullPath === "/register") {
                next();
              } else {
                next("/register");
              }
            } else {
              console.log("getWxCode接口返回数据异常，response:", res);
            }
          })
          .catch(function(err) {
            console.log("请求getWxCode接口异常，err:", err);
          });
      } else {
        //请求微信服务器获取code
        //不存在code，第一次跳转
        let redirect_uri = encodeURIComponent(location.href); //跳转
        //alert("编码路由=" + redirect_uri);
        let appID = store.state.app_id;
        //let appSecret = 'd048d6f0f6b9bfbf5cf206cd883ece3b'
        //let u = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appID}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=1&connect_redirect=1#wechat_redirect`;
        let u = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appID}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect`;
        location.href = u;
        next();
      }
    }
  } else {
    next();
  }
};

let testflag = false;
router.beforeEach((to, from, next) => {
  if (testflag) {
    next();
    return;
  }
  let routers = router.options.routes;
  let b = false;
  let p = '';
  const _user = Storage.get('upmsUser');
  //用户当前角色名
  const _rolename = _user && 'menu_item' in _user?_user.menu_item.split(','):[]
  routers.forEach(function(item) {
    if(to.path === '/'){
      next()
    }
    if (item.path === to.path || `/${item.path}` ===to.path) {
      b = true;
      if('meta' in item){
        p = _rolename.indexOf(item.meta.menuName)>-1?'':from.fullPath
      }
    }
    if (item["children"]) {item["children"].forEach(function(m) {
        if (m.path === to.path || `/${m.path}` ===to.path) {
          b = true;
          if('meta' in m){
            p = _rolename.indexOf(m.meta.menuName)>-1?'':from.fullPath
          }
        }
      });
    }
  });
  //b=true;判断路由配置中是否存在当前路由
  if (b === true) {
    window.clearInterval(store.state.interObj);
    store.dispatch("removeInter")
    // 不具备页面权限
    if(p !== ''){
      Notify({ type: "danger", message: "没有权限！" })
      if (from.fullPath === p) {
        next(p);
        return;
      }
    }
    // 区分新版注册流程
    if(from.name==='register' && to.name==='permissions'){
      next()
    }else {
      //第一次进入H5页面进行token验证
      store.dispatch("checkTokens", {
        ele: Vue.prototype,
        success: function() {
          authorization(Storage.get("upmsUser"), to, from, next);
        },
        fail: function() {
          store.dispatch("getTokens", {
            ele: Vue.prototype,
            success: function() {
              //token 获取成功后获取当前用户信息
              store.dispatch("getUpmsUser", {
                ele: Vue.prototype,
                success: function(result) {
                  authorization(result, to, from, next);
                },
                fail: function(err) {
                  console.log(
                      err
                          ? "获取用户信息失败：" + err
                          : "不存在用户信息：缺少openid"
                  );
                  authorization("", to, from, next);
                }
              });
            }
          });
        }
      });
    }
  } else {
    //不存在路由
    console.log("没有找到{" + to.path + "}");
    //不存在这个页面
    //next("/404");
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
